import React from 'react'
import { StyledflexSpacebetween } from './Styled'
import { dateFormatting } from '../Utility/apiHelper'
import { useSelector } from 'react-redux'
import { handleValidateCodevalue } from '../Utility/constant'
import TextFiledWithLabel from './TextFieldWithLabel'

const WhoColumnTextfieds = ({entityDetails}) => {
  
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData)
  return (
      <StyledflexSpacebetween>
              <div className='date-container-search'>
    <TextFiledWithLabel
        name="id"
        id="id" 
        variant='standard'
        value={dateFormatting(entityDetails?.createdAt || "")}
        disabled={true}
        type = 'date'
        label={handleValidateCodevalue(internationalise,'COMMON_CREATED_AT')}
        // InputLabelProps={{
        // shrink: true,
        // }}
    />
    <TextFiledWithLabel
        name="id"
        id="id" 
        variant='standard'
        value={entityDetails?.createdByName ?? ""}
        disabled={true}
        label={handleValidateCodevalue(internationalise,'COMMON_CREATED_BY')}
        // InputLabelProps={{
        // shrink: true,
        // }}
    />
        </div>
    <div className='date-container-search'>
            <TextFiledWithLabel 
        name="id"
        id="id" 
        variant='standard'
        value={dateFormatting(entityDetails?.updatedAt || "")}
        disabled={true}
        label={handleValidateCodevalue(internationalise,'COMMON_UPDATED_AT')}
        type='date'
        // InputLabelProps={{
        // shrink: true,
        // }}
    />
    <TextFiledWithLabel 
        name="id"
        id="id" 
        variant='standard'
        value={entityDetails?.updatedByName || ""}
        disabled={true}
        label={handleValidateCodevalue(internationalise,'COMMON_UPDATED_BY')}
        // InputLabelProps={{
        // shrink: true,
        // }}
    />
        </div>
    </StyledflexSpacebetween>
  )
}

export default WhoColumnTextfieds